import { TMessageSchema } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TMessagesMap } from '../../utils/messageUtils';

export enum EChatActionTypes {
  IncomingMessage = 'chat/incomingMessage',
  SetEditableMessage = 'chat/setEditableMessage',
  SetCaptchaToken = 'chat/setCaptchaToken',
  DisableSendDefaultMessage = 'chat/disableSendDefaultMessage',
  SetBubbleInputFocus = 'chatWindow/setBubbleInputFocus',
}

export type TEditableMessagePayload = {
  chatId: string;
  text: string;
  payload?: string;
};

export type TSetCaptchaTokenPayload = {
  chatId: string;
  captchaToken?: string;
};

export type TIncomingMessagePayload = {
  message: TMessageSchema;
  messagesMap: TMessagesMap;
};

export type TDisableSendDefaultMessagePayload = {
  chatId: string;
};

export type TBubbleInputFocusPayload = {
  isBubbleInputFocused: boolean;
};

export type TChatActions =
  | ITypedReduxAction<EChatActionTypes.IncomingMessage, TIncomingMessagePayload>
  | ITypedReduxAction<EChatActionTypes.SetEditableMessage, TEditableMessagePayload>
  | ITypedReduxAction<EChatActionTypes.SetCaptchaToken, TSetCaptchaTokenPayload>
  | ITypedReduxAction<EChatActionTypes.DisableSendDefaultMessage, TDisableSendDefaultMessagePayload>
  | ITypedReduxAction<EChatActionTypes.SetBubbleInputFocus, TBubbleInputFocusPayload>;
